import Link from '@components/common/Link';
import Tooltip from '@components/common/Tooltip';
import { useGetPositionLifetimeInDays } from '@components/store/getters';
import { TableHead } from './PositionTableHead.styles';

export default function PositionTableHead() {
  const positionLifetimeInDays = useGetPositionLifetimeInDays();
  return (
    <TableHead>
      <tr>
        <th scope="col">Opened</th>
        <th scope="col">Collateral</th>
        <th scope="col">Borrowed</th>
        <th scope="col">Total Position Value</th>
        <th scope="col">Interest Earned</th>
        <th scope="col">
          Expires
          <Tooltip position="center" name="DashExpiry">
            <p>
              Positions automatically expire/unwind {positionLifetimeInDays} days after the open date. Your funds
              (collateral + earnings) can then be claimed any time on the{' '}
              <Link href="/dashboard" className="font-bold underline">
                My Dashboard
              </Link>{' '}
              page.
            </p>
          </Tooltip>
        </th>
        <th scope="col">&nbsp;</th>
        <th scope="col"></th>
      </tr>
    </TableHead>
  );
}
